<template>
    <svg viewBox="0 0 1080 260" preserveAspectRatio="none">
        <path d="M0,0 1080,260 1080,0 0,0" fill="#e2e1d7" >
        </path>
        <text x="280" y="-15" transform="rotate(13)" fill="#333" font-size="2rem" font-style="italic">
            <slot></slot>
        </text>
    </svg>
</template>

<script>
    export default {
        name: "Slogen"
    }
</script>

<style lang="scss" scoped>
    $slogenWidth: 45vw;

    svg {
        z-index: 999;
        position: fixed;
        top: 0;
        right: 0;
        width: 60vw;
        pointer-events: none;
    }
</style>
